"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactStatusHistory = void 0;
var ContactStatusHistory = /** @class */ (function () {
    function ContactStatusHistory() {
    }
    return ContactStatusHistory;
}());
exports.ContactStatusHistory = ContactStatusHistory;
//# sourceMappingURL=ContactStatusHistory.js.map